import {AfterViewInit, Component, Inject, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatHorizontalStepper,
  MatStepper
} from '@angular/material';
import {DelegationListComponent} from '../delegation-list/delegation-list.component';
import {DelegationService} from '../delegation.service';
import {Delegation, DelegationParams, DelegationUoVo} from '../../../model/delegation';
import * as moment from 'moment';
import {DATE_DEFAULT_FORMAT} from '../../../model/commons/DateConstants';
import {Delegate, Uo} from '../../../model/delegationUo';
import {Router} from '@angular/router';
import {MAT_DATE_FORMATS} from '@angular/material/core';
import {MomentDateAdapter} from '@angular/material-moment-adapter';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-modal-delegation',
  templateUrl: './modal-delegation.component.html',
  styleUrls: ['./modal-delegation.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})

export class ModalDelegationComponent implements OnInit, AfterViewInit {

  searchDelegator: string = '';
  searchUO: string = '';
  todayDate: Date = new Date();
  delegates: Delegate[] = [];
  indexPrepareData: number[] = [0];
  delegatorsSelected: Delegate[] = [];
  delegatorSelected: Delegate = new Delegate();
  validationInjectionSingleStep4: boolean = false;
  validationInjectionMasseStep4: boolean = false;
  reopenFileStep4: boolean = false;
  unlockingPlugStep4: boolean = false;
  fileValidationStep4: boolean = false;
  delegatorsSelectedStep4: Delegate[] = [];
  uoList: Uo[] = [];
  isLinear = false;
  current: number = 1;
  validationInjectionSingleChecked: boolean = false;
  validationInjectionMasseChecked: boolean = false;
  reopenFileChecked: boolean = false;
  unlockingPlugChecked: boolean = false;
  fileValidationChecked: boolean = false;
  matricule: string = '';
  injectionSingle: Delegate[] = [];
  validationInjectionMasse: Delegate[] = [];
  unlockingPlug: Delegate[] = [];
  fileValidation: Delegate[] = [];
  reopenFile: Delegate[] = [];

  constructor(private _formBuilder: FormBuilder,
              public dialog: MatDialog,
              private router: Router,
              private delegationService: DelegationService,
              @Inject(MAT_DIALOG_DATA) public injectData,
              public dialogRef: MatDialogRef<DelegationListComponent>) {
  }

  @ViewChild('stepper') public myStepper: MatStepper;
  totalStepsCount: number;

  ngOnInit() {
    this.matricule = this.injectData.matricule;
    this.uoList = this.injectData && this.injectData.uoAndUsers && this.injectData.uoAndUsers.Uos ? Object.assign([], this.injectData.uoAndUsers.Uos) : [];
    this.delegates = this.injectData && this.injectData.uoAndUsers && this.injectData.uoAndUsers.delegates ? Object.assign([], this.injectData.uoAndUsers.delegates) : [];
    this.delegates = this.delegates.filter(del => del.matricule != this.matricule);
    if (this.delegates.length == 0 && this.uoList.length == 0) {
      this.loadDelegations(this.matricule);
    }
    this.getDelegationHabilitationParams();
  }

  goBack(stepper: MatStepper) {
    if (stepper.selectedIndex === 0) {
      this.dialogRef.close();
    } else {
      stepper.previous();
    }

  }

  goForward(stepper: MatStepper) {
    if (this.shouldNextStepBeDisabled(stepper.selectedIndex)) {
      return;
    }
    if (stepper.selectedIndex == 0) {
      this.delegates.forEach(d => {
        d.validationInjectionSingleChecked = this.validationInjectionSingleChecked;
        d.validationInjectionMasseChecked = this.validationInjectionMasseChecked;
        d.unlockingPlugChecked = this.unlockingPlugChecked;
        d.fileValidationChecked = this.fileValidationChecked;
        d.reopenFileChecked = this.reopenFileChecked;
      });
    }
    if (stepper.selectedIndex == 2) {
      let delegationResult: any[] = [];
      this.delegatorsSelected.forEach((d, index) => {
        if (d.validationInjectionSingleChecked) {
          let dd = Object.assign({}, d);
          dd.validationInjectionMasseChecked = false;
          dd.unlockingPlugChecked = false;
          dd.fileValidationChecked = false;
          dd.reopenFileChecked = false;
          delegationResult.push(dd);
        }
        if (d.validationInjectionMasseChecked) {
          let dd = Object.assign({}, d);
          dd.validationInjectionSingleChecked = false;
          dd.unlockingPlugChecked = false;
          dd.fileValidationChecked = false;
          dd.reopenFileChecked = false;
          delegationResult.push(dd);
        }
        if (d.unlockingPlugChecked) {
          let dd = Object.assign({}, d);
          dd.validationInjectionSingleChecked = false;
          dd.validationInjectionMasseChecked = false;
          dd.fileValidationChecked = false;
          dd.reopenFileChecked = false;
          delegationResult.push(dd);
        }
        if (d.fileValidationChecked) {
          let dd = Object.assign({}, d);
          dd.validationInjectionSingleChecked = false;
          dd.validationInjectionMasseChecked = false;
          dd.unlockingPlugChecked = false;
          dd.reopenFileChecked = false;
          delegationResult.push(dd);
        }
        if (d.reopenFileChecked) {
          let dd = Object.assign({}, d);
          dd.validationInjectionSingleChecked = false;
          dd.validationInjectionMasseChecked = false;
          dd.unlockingPlugChecked = false;
          dd.fileValidationChecked = false;
          delegationResult.push(dd);
        }
      });

      //this.delegatorsSelected = delegationResult;
      this.delegatorsSelectedStep4 = delegationResult;
      this.injectionSingle = this.findDelegationByAuthorisation('validationInjectionSingle');
      this.validationInjectionMasse = this.findDelegationByAuthorisation('validationInjectionMasse');
      this.unlockingPlug = this.findDelegationByAuthorisation('unlockingPlug');
      this.fileValidation = this.findDelegationByAuthorisation('fileValidation');
      this.reopenFile = this.findDelegationByAuthorisation('reopenFile');

    }
    if (stepper.selectedIndex == 3) {
      let payload: Delegation[] = [];
      this.delegatorsSelectedStep4.forEach(d => {
        let delegation: Delegation = new Delegation();
        delegation.createdBy = d.matricule;
        delegation.delegate = d.matricule;
        delegation.fullName = d.fullName;

        delegation.deleted = false;
        delegation.dirSite = this.matricule;
        delegation.function = d.job;
        d.uoSelected.forEach(uo => {
          let delegationUoVoOne: DelegationUoVo = new DelegationUoVo();
          delegationUoVoOne.createdBy = this.matricule;
          delegationUoVoOne.name = uo.name;
          delegationUoVoOne.uoId = uo.id;
          delegationUoVoOne.updatedBy = this.matricule;
          delegation.delegationUoVo.push(delegationUoVoOne);
        });
        let delegationParam: DelegationParams = new DelegationParams();
        delegationParam.id = this.getIDDelegationParam(d);
        delegationParam.createdBy = this.matricule;
        delegationParam.deleted = false;
        delegationParam.label = this.getIDDelegationParam(d, 'label');
        delegationParam.startDate = moment(d.startDate).format(DATE_DEFAULT_FORMAT);
        delegationParam.endDate = moment(d.endDate).format(DATE_DEFAULT_FORMAT);
        delegation.delegationParams = delegationParam;
        payload.push(delegation);
      });

      console.log('payload : ', payload);
      this.saveDelegation(payload);
    }

    this.indexPrepareData.push(stepper.selectedIndex + 1);
    stepper.next();
  }

  // Event fired after view is initialized
  ngAfterViewInit() {
    this.totalStepsCount = this.myStepper._steps.length;
  }

  selectDelegation(delegator: any) {
    delegator.isClickUO = !delegator.isClickUO;
    this.uoList.forEach(uo => {
      uo.isClick = delegator.uoSelected && delegator.uoSelected.filter(uoS => uoS.id === uo.id).length > 0;
    });
    if (this.delegatorsSelected) {
      this.delegatorsSelected.forEach(d => {
        if (d.matricule != delegator.matricule) {
          d.isClickUO = false;
        }
      });
    }
    this.delegatorSelected = delegator;

  }

  loadDelegations(matricule: string) {
    this.delegationService.loadAllDelegation(matricule).subscribe(res => {
      this.uoList = res.Uos;
      this.delegates = res.delegates;
      this.delegates = this.delegates.filter(del => del.matricule != this.matricule);

    });
  }

  selectDelegator(delegator: any, authorisationType: string) {
    switch (authorisationType) {
      case 'validationInjectionSingle' : {
        delegator.validationInjectionSingleChecked = !delegator.validationInjectionSingleChecked;
        if (delegator.validationInjectionSingleChecked) {
          if (this.delegatorsSelected.filter(d => d.matricule === delegator.matricule).length == 0) {
            this.delegatorsSelected.push(delegator);
          }
        } else if (!this.checkIsOneAuthSelected(delegator)) {
          this.delegatorsSelected = this.delegatorsSelected.filter(d => d.matricule != delegator.matricule);
        }
        break;
      }
      case 'validationInjectionMasse' : {
        delegator.validationInjectionMasseChecked = !delegator.validationInjectionMasseChecked;
        if (delegator.validationInjectionMasseChecked) {
          if (this.delegatorsSelected.filter(d => d.matricule === delegator.matricule).length == 0) {
            this.delegatorsSelected.push(delegator);
          }
        } else if (!this.checkIsOneAuthSelected(delegator)) {
          this.delegatorsSelected = this.delegatorsSelected.filter(d => d.matricule != delegator.matricule);
        }
        break;
      }
      case 'unlockingPlug' : {
        delegator.unlockingPlugChecked = !delegator.unlockingPlugChecked;
        if (delegator.unlockingPlugChecked) {
          if (this.delegatorsSelected.filter(d => d.matricule === delegator.matricule).length == 0) {
            this.delegatorsSelected.push(delegator);
          }
        } else if (!this.checkIsOneAuthSelected(delegator)) {
          this.delegatorsSelected = this.delegatorsSelected.filter(d => d.matricule != delegator.matricule);
        }
        break;
      }
      case 'fileValidation' : {
        delegator.fileValidationChecked = !delegator.fileValidationChecked;
        if (delegator.fileValidationChecked) {
          if (this.delegatorsSelected.filter(d => d.matricule === delegator.matricule).length == 0) {
            this.delegatorsSelected.push(delegator);
          }
        } else if (!this.checkIsOneAuthSelected(delegator)) {
          this.delegatorsSelected = this.delegatorsSelected.filter(d => d.matricule != delegator.matricule);
        }
        break;
      }

      case 'reopenFile' : {
        delegator.reopenFileChecked = !delegator.reopenFileChecked;
        if (delegator.reopenFileChecked) {
          if (this.delegatorsSelected.filter(d => d.matricule === delegator.matricule).length == 0) {
            this.delegatorsSelected.push(delegator);
          }
        } else if (!this.checkIsOneAuthSelected(delegator)) {
          this.delegatorsSelected = this.delegatorsSelected.filter(d => d.matricule != delegator.matricule);
        }
        break;
      }

    }
  }

  setUoToDelegator(uo: any) {
    if (this.delegatorsSelected.filter(d => d.isClickUO).length > 0) {
      uo.isClick = !uo.isClick;
      if (uo.isClick) {
        if (this.delegatorSelected) {
          if (!this.delegatorSelected.uoSelected) {
            this.delegatorSelected.uoSelected = [];
          }

          this.delegatorSelected.uoSelected.push(uo);

        }

      } else if (this.delegatorSelected.uoSelected) {
        this.delegatorSelected.uoSelected = this.delegatorSelected.uoSelected.filter(u => u.id != uo.id);
      }
    }
  }

  checkIsAuthorisationExist(authorisationType: string) {
    switch (authorisationType) {
      case 'validationInjectionSingle' : {
        return this.delegatorsSelected.filter(d => d.validationInjectionSingleChecked).length > 0;
      }
      case 'validationInjectionMasse' : {
        return this.delegatorsSelected.filter(d => d.validationInjectionMasseChecked).length > 0;
      }
      case 'unlockingPlug' : {
        return this.delegatorsSelected.filter(d => d.unlockingPlugChecked).length > 0;
      }
      case 'fileValidation' : {
        return this.delegatorsSelected.filter(d => d.fileValidationChecked).length > 0;
      }
      case 'reopenFile' : {
        return this.delegatorsSelected.filter(d => d.reopenFileChecked).length > 0;
      }


    }

    return false;

  }

  findDelegationByAuthorisation(authorisationType: string): Delegate[] {
    switch (authorisationType) {
      case 'validationInjectionSingle' :
        return this.delegatorsSelectedStep4.filter(d => d.validationInjectionSingleChecked);
      case 'validationInjectionMasse' :
        return this.delegatorsSelectedStep4.filter(d => d.validationInjectionMasseChecked);
      case 'unlockingPlug' :
        return this.delegatorsSelectedStep4.filter(d => d.unlockingPlugChecked);
      case 'fileValidation' :
        return this.delegatorsSelectedStep4.filter(d => d.fileValidationChecked);
      case 'reopenFile' :
        return this.delegatorsSelectedStep4.filter(d => d.reopenFileChecked);


    }
    return [];
  }

  private getIDDelegationParam(d: Delegate, label?: string): any {
    if (d.validationInjectionSingleChecked) {
      return label === 'label' ? 'INJECTION' : 1;
    }
    if (d.validationInjectionMasseChecked) {
      return label === 'label' ? 'INJECTION EN MASSE' : 5;
    }
    if (d.fileValidationChecked) {
      return label === 'label' ? 'VALIDATION' : 4;
    }
    if (d.reopenFileChecked) {
      return label === 'label' ? 'REOUVERTURE' : 2;
    }
    if (d.unlockingPlugChecked) {
      return label === 'label' ? 'DEVEROUILLAGE' : 3;
    }

    return 0;
  }

  private saveDelegation(payload: Delegation[]) {
    this.delegationService.saveDelegation(payload, this.matricule).subscribe(res => {
      this.dialogRef.close();
      console.log('res : ', res);
      this.indexPrepareData = [];
      this.delegationService.redirectTo('delegation');
    });
  }


  private checkIsOneAuthSelected(d: Delegate) {
    return d.validationInjectionSingleChecked || d.validationInjectionMasseChecked || d.unlockingPlugChecked || d.reopenFileChecked || d.fileValidationChecked;
  }

  shouldNextStepBeDisabled(selectedIndex: number) {
    switch (selectedIndex) {
      case 0:
        return !this.validationInjectionSingleChecked && !this.validationInjectionMasseChecked && !this.unlockingPlugChecked && !this.reopenFileChecked && !this.fileValidationChecked;
      case 1:
        return this.delegatorsSelected.length <= 0;
      case 2:
        return this.delegatorsSelected.filter(d => this.checkIfUOsAreSelected(d)).length > 0;
      case 3:
        return this.delegatorsSelectedStep4.filter(d => this.checkStartEndDateAfterCurrent(d)).length > 0;
    }

    return false;

  }

  addDelegateToList(delegator: any) {
    delegator.isClick = !delegator.isClick;
    if (delegator.isClick) {
      if (this.delegatorsSelected.filter(dd => dd.matricule === delegator.matricule).length <= 0) {
        this.delegatorsSelected.push(delegator);
      }
    } else {
      this.delegatorsSelected = this.delegatorsSelected.filter(d => d.matricule != delegator.matricule);
    }
  }

  private checkIfUOsAreSelected(d: Delegate) {
    return !d.uoSelected || d.uoSelected.length <= 0;
  }

  onDisableDates(delegator: any, date) {
    console.log('date : ', date);
  }

  selectAllDelegate: boolean = false;

  selectAll() {
    this.selectAllDelegate = !this.selectAllDelegate;
    if (this.selectAllDelegate) {
      this.delegates.forEach(d => d.isClick = true);
      this.delegatorsSelected = this.delegates;
    } else {
      this.delegates.forEach(d => d.isClick = false);
      this.delegatorsSelected = [];
    }
  }

  private getDelegationHabilitationParams() {
    this.delegationService
      .getDelegationHabilitationParams()
      .subscribe(res => console.log('RR : ', res));
  }

  selectAllUos() {
    if (this.checkSelectOneDelegate()) {
      this.delegatorSelected.selectAllUo = !this.delegatorSelected.selectAllUo;
      if (this.delegatorSelected.selectAllUo) {
        this.delegatorSelected.uoSelected = this.uoList;
        this.delegatorSelected.uoSelected.forEach(uo => uo.isClick = true);
      } else {
        this.delegatorSelected.uoSelected.forEach(uo => uo.isClick = false);
        this.delegatorSelected.uoSelected = [];
      }
    }
  }

  checkSelectOneDelegate() {
    return this.delegatorsSelected.filter(d => d.isClickUO).length > 0;
  }

  checkSelectAllActive() {
    if (!this.checkSelectOneDelegate()) {
      return false;
    }

    return this.delegatorSelected.selectAllUo;
  }


  deleteUo(delegator: Delegate, uoDeleted: Uo) {
    if (delegator.uoSelected.length > 1) {
      delegator.uoSelected = delegator.uoSelected.filter(uo => uo.id != uoDeleted.id);
    }
  }

  private checkStartEndDateAfterCurrent(d: Delegate) {
    let startDate = moment(d.startDate).format(DATE_DEFAULT_FORMAT);
    let endDate = moment(d.endDate).format(DATE_DEFAULT_FORMAT);
    let today = moment(new Date()).format(DATE_DEFAULT_FORMAT);
    return !d.startDate || !d.endDate || moment(startDate).isAfter(moment(endDate)) || moment(startDate).isBefore(moment(today))
  }
  breadcrumbSelect(stepper: MatHorizontalStepper, indexBreadcrumbSelected: number) {
    if (indexBreadcrumbSelected === stepper.selectedIndex || !this.indexPrepareData.includes(indexBreadcrumbSelected)) return;
    if (indexBreadcrumbSelected < stepper.selectedIndex || indexBreadcrumbSelected == 0 || this.indexPrepareData.includes(indexBreadcrumbSelected)){
      this.myStepper.selectedIndex = indexBreadcrumbSelected;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/delegation/modal-delegation/modal-delegation.component.ts